import { db } from '$db/local/db';
import type { UUID } from '$domain/types';

/**
 * Convención de claves en syncMeta (M4.1).
 * Se construyen siempre con los helpers de abajo, nunca a mano.
 */
export async function getSyncMeta<T = unknown>(
  key: string
): Promise<T | undefined> {
  const row = await db.syncMeta.get(key);
  return row?.value as T | undefined;
}

export async function setSyncMeta(
  key: string,
  value: unknown
): Promise<void> {
  await db.syncMeta.put({ key, value });
}

export async function deleteSyncMeta(key: string): Promise<void> {
  await db.syncMeta.delete(key);
}

export function lastPullCursorKey(userId: UUID, entityType: string): string {
  return `sync.lastPullCursor:${userId}:${entityType}`;
}

export function lastPushAtKey(userId: UUID): string {
  return `sync.lastPushAt:${userId}`;
}

export function schemaVersionKey(userId: UUID): string {
  return `sync.schemaVersion:${userId}`;
}

export function quarantineBytesKey(userId: UUID): string {
  return `sync.quarantineBytes:${userId}`;
}

export function entitySchemaVersionKey(entityType: string): string {
  return `entitySchemaVersion:${entityType}`;
}

export function staleKey(
  userId: UUID,
  entityType: string,
  entityId: string
): string {
  return `stale:${userId}:${entityType}:${entityId}`;
}